import { render, staticRenderFns } from "./seccion.vue?vue&type=template&id=4b8c9485&"
import script from "./seccion.vue?vue&type=script&lang=js&"
export * from "./seccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports